import { TransformedExtendedWarranty } from "../../utils/serviceMapper";
import { useServicesAndWarrantiesContext } from "../../ServicesAndWarrantiesContext";
import { useRef, useState, ChangeEvent } from "react";
import styles from "./ExtendedWarranties.module.scss";
import Checkbox from "@JohnLewisPartnership/jl-design-system/dist/components/checkbox/Checkbox";
import classNames from "classnames/bind";

const cx = classNames.bind(styles);

type Props = {
  availableToOrder: boolean;
  warranties: TransformedExtendedWarranty[];
  extendedWarrantiesAnalyticsHandler: (warrantyTitle: string) => void;
};

export function ExtendedWarranties({
  availableToOrder,
  warranties,
  extendedWarrantiesAnalyticsHandler,
}: Props) {
  const { toggleSelectedService } = useServicesAndWarrantiesContext();
  const infoButtonRef = useRef<HTMLButtonElement>(null);
  const [showInfo, setShowInfo] = useState(false);

  const handleTooltipCollapseClick = () => setShowInfo(false);
  const handleTooltipExpandClick = () => {
    setShowInfo(!showInfo);
    infoButtonRef.current?.focus();
  };
  const handleToggleSelectedServiceClick =
    (warrantyId: string, warrantyTitle: string) =>
    (e: ChangeEvent<HTMLFormElement>) => {
      toggleSelectedService(warrantyId);
      if (e.target?.checked) {
        extendedWarrantiesAnalyticsHandler(warrantyTitle);
      }
    };

  if (!warranties.length) return null;

  return (
    <div
      className={styles.extendedWarrantiesContainer}
      data-testid="product:extended-warranties"
    >
      {warranties.map((warranty, index) => {
        return (
          <section key={`warranty:${index}`}>
            <h2
              data-testid="product:extended-warranties:title"
              className={styles.title}
            >
              {warranty.title}
            </h2>
            <div className={styles.warrantyItem}>
              <Checkbox
                isControlled={true}
                className={styles.warrantyInfo}
                id={warranty.title}
                label={warranty.purchaseDescription}
                ariaLabel={warranty.purchaseDescription}
                checked={warranty.selected}
                onClick={handleToggleSelectedServiceClick(
                  warranty.id,
                  warranty.title,
                )}
                name={warranty.title}
                value={""}
                additionalInfo={warranty.display}
                disabled={!availableToOrder}
              />
              <button
                data-testid="product:extended-warranty:tooltip:button:expand"
                className={styles.warrantyToolTip}
                aria-label={`${warranty.title} information`}
                ref={infoButtonRef}
                onClick={handleTooltipExpandClick}
              >
                {" "}
              </button>
            </div>

            <div
              data-testid="product:extended-warranty:tooltip"
              className={cx(styles.infoBlock, { hide: !showInfo })}
            >
              <button
                aria-label="Collapse tooltip"
                data-testid="product:extended-warranty:tooltip:button:collapse"
                onClick={handleTooltipCollapseClick}
                className={styles.closeButton}
              ></button>
              <div aria-live="polite">
                <div
                  dangerouslySetInnerHTML={{
                    __html: `${warranty.tooltip}`,
                  }}
                />
              </div>
            </div>

            <div
              data-testid="product:extended-warranty:detail"
              className={styles.policyDetail}
              dangerouslySetInnerHTML={{
                __html: `${
                  warranty.selected
                    ? warranty.confirmation
                    : warranty.policyDetail
                }`,
              }}
            />
          </section>
        );
      })}
    </div>
  );
}
